// image-picker.js
;(async ({ $, $$, log, getTranslation }) => {
    const translation = await getTranslation('image-picker')

    const actionHiddenClass = 'image-picker__action--hidden'
    const errorHiddenClass = 'image-picker__error--hidden'
    const previewBoxHiddenClass = 'image-picker__preview-box--hidden'

    $$('.image-picker').forEach(picker => {
        const input = picker.querySelector('.image-picker__input')
        const actionDelete = picker.querySelector('.image-picker__action--delete')
        const errorBox = picker.querySelector('.image-picker__error')
        const previewBox = picker.querySelector('.image-picker__preview-box')
        const preview = picker.querySelector('.image-picker__preview')
        const filename = picker.querySelector('.image-picker__filename')
        const reader = new FileReader()
        const allowedFormats = picker.dataset.allowedFormats.split('|')
        
        init()

        function init() {
            // clearPicker(true)
            hideDeleteAction()

            input.addEventListener('change', event => {
                clearPicker()

                const file = event.target.files[0]

                if (!isFileTypeAllowed(file.type)) {
                    clearPicker()
                    showError(translation.errors['file-type-invalid'] + allowedFormats.join(', '))
                    return
                }

                reader.readAsDataURL(file)
                filename.innerHTML = file.name
            })

            reader.addEventListener('load', () => {
                if (preview) {
                    preview.src = reader.result
                }
                showPreview()
                showDeleteAction()
            })

            actionDelete.addEventListener('click', event => {
                event.preventDefault()
                clearPicker(true)
            })
        }

        function hideDeleteAction() {
            actionDelete.classList.add(actionHiddenClass)
        }

        function showDeleteAction() {
            actionDelete.classList.remove(actionHiddenClass)
        }

        function clearPicker(eraseFile = false) {
            if (eraseFile) {
                input.value = ''
            }
            filename.innerHTML = ''
            hideDeleteAction()
            hideError()
            hidePreview()
        }

        function showError(msg) {
            errorBox.innerHTML = msg
            errorBox.classList.remove(errorHiddenClass)
        }

        function hideError() {
            errorBox.classList.add(errorHiddenClass)
        }

        function showPreview() {
            previewBox.classList.remove(previewBoxHiddenClass)
        }

        function hidePreview() {
            previewBox.classList.add(previewBoxHiddenClass)
        }

        function isFileTypeAllowed(type) {
            let allowed = false
            const slashPos = type.lastIndexOf('/')
            type = type.slice(slashPos + 1)
            // console.log(type)
            allowedFormats.forEach(allowedType => {
                if (allowedType.toLowerCase() == type.toLowerCase()) {
                    // console.log(allowedType.toLowerCase(), type.toLowerCase())
                    allowed = true
                }
            })

            return allowed
        }
    })
})(CNS);